import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Film as FilmType } from '../types';
import { Badge } from './ui/Badge';
import { Film as FilmIcon, Play } from 'lucide-react';
import { motion } from 'framer-motion';
interface FilmCardProps {
  film: FilmType;
  index?: number;
}
export function FilmCard({
  film,
  index = 0
}: FilmCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: index * 0.1,
    ease: 'easeOut'
  }} className="group h-full" data-id="element-27">
      <Link to={`/film/${film.id}`} className="block h-full" data-id="element-28">
        <div className="bg-[#141414] border border-[#333] h-full flex flex-col transition-all duration-500 hover:border-[#D22B2B]/50 hover:shadow-[0_0_30px_rgba(210,43,43,0.15)] relative overflow-hidden" data-id="element-29">
          {/* Film Strip Decoration Left */}
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-black z-20 flex flex-col gap-1 py-1 opacity-50" data-id="element-30">
            {Array.from({
            length: 20
          }).map((_, i) => <div key={i} className="w-0.5 h-1 bg-[#333] mx-auto rounded-[1px]" data-id="element-31"></div>)}
          </div>

          {/* Poster Image */}
          <div className="aspect-[2/3] w-full relative overflow-hidden bg-[#0a0a0a]" data-id="element-32">
            {film.posterUrl ? <>
                <img src={film.posterUrl} alt={`Постер фильма ${film.title}`} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100 grayscale group-hover:grayscale-0" loading="lazy" data-id="element-33" />
                {/* Vignette Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-transparent to-transparent opacity-90" data-id="element-34"></div>

                {/* Play Icon Reveal */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-35">
                  <div className="w-12 h-12 rounded-full border border-white/30 bg-black/50 backdrop-blur-sm flex items-center justify-center" data-id="element-36">
                    <Play className="w-4 h-4 text-white fill-white ml-0.5" data-id="element-37" />
                  </div>
                </div>
              </> : <div className="w-full h-full flex flex-col items-center justify-center text-gray-700" data-id="element-38">
                <FilmIcon className="w-12 h-12 mb-4 opacity-20" data-id="element-39" />
                <span className="font-serif text-xs uppercase tracking-widest opacity-40" data-id="element-40">
                  Нет пленки
                </span>
              </div>}

            {/* Catalog Number Badge */}
            <div className="absolute top-3 right-3 bg-black/80 backdrop-blur text-white text-[9px] font-serif tracking-widest px-2 py-1 border border-white/10" data-id="element-41">
              № {film.catalogNumber}
            </div>
          </div>

          {/* Content */}
          <div className="p-5 flex flex-col flex-grow relative" data-id="element-42">
            <div className="flex items-start justify-between gap-2 mb-3" data-id="element-43">
              <h3 className="font-noir text-xl leading-tight text-gray-200 group-hover:text-[#D22B2B] transition-colors duration-300" data-id="element-44">
                {film.title}
              </h3>
              <span className="text-xs font-serif text-gray-500 shrink-0 mt-1" data-id="element-45">
                {film.year}
              </span>
            </div>

            <p className="text-xs text-gray-500 line-clamp-2 mb-5 font-light leading-relaxed font-serif" data-id="element-46">
              {film.descriptionExcerpt}
            </p>

            <div className="mt-auto space-y-4" data-id="element-47">
              {/* Meta Info */}
              <div className="text-[10px] text-gray-600 border-t border-[#222] pt-3 font-serif tracking-wide uppercase" data-id="element-48">
                <p className="mb-1" data-id="element-49">
                  <span className="text-gray-400" data-id="element-50">Реж:</span> {film.director}
                </p>
                <p className="truncate" data-id="element-51">
                  <span className="text-gray-400" data-id="element-52">В ролях:</span>{' '}
                  {film.cast.slice(0, 2).join(', ')}
                </p>
              </div>

              {/* Tags */}
              <div className="flex flex-wrap gap-1.5" data-id="element-53">
                <Badge variant="outline" className="border-[#333] text-gray-500" data-id="element-54">
                  {film.ageCategory}
                </Badge>
                {film.genreTags.slice(0, 2).map(genre => <Badge key={genre} variant="default" className="bg-[#1a1a1a] text-gray-400 border-[#333]" data-id="element-55">
                    {genre}
                  </Badge>)}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>;
}